import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { PageHeader } from "../components/ui-bits";
import { Card, fmtDate } from "../components/sampling/common";

export default function SamplingDigestPage() {
  const { id } = useParams();
  const nav = useNavigate();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/sampling/digests/${id}`).then(r => setD(r.data)).catch(() => setErr("Riepilogo non trovato")); }, [id]);
  if (err) return <div className="text-sm text-red-600" data-testid="digest-error">{err}</div>;
  if (!d) return <div className="text-sm opacity-60">Caricamento…</div>;
  const open = (gid) => nav(`/garments/${gid}/development`);
  const Row = ({ x, children }) => (
    <button onClick={() => open(x.id)} className="w-full text-left py-3 border-b last:border-0 text-sm" style={{ borderColor: "var(--border)" }} data-testid={`digest-row-${x.id}`}>
      <div className="flex flex-wrap justify-between gap-2"><span><b>{x.code}</b> {x.name} <span className="text-xs opacity-60">· {x.collection || "—"} · {x.stage}</span></span>{children}</div>
    </button>
  );
  return (
    <div data-testid="sampling-digest-page">
      <PageHeader eyebrow="Riepilogo settimanale" title="Campionario" description={`Generato il ${fmtDate(d.created_at)}`}/>
      <Card title={`Campioni in ritardo (${d.overdue.length})`} testId="digest-overdue">
        {d.overdue.length === 0 ? <div className="text-sm opacity-60">Nessun campione in ritardo.</div> :
          d.overdue.map(x => <Row key={x.id} x={x}><span className="text-red-600 text-xs">scadenza {fmtDate(x.due)}</span></Row>)}
      </Card>
      <Card title={`Informazioni ancora mancanti (${d.missing.length} capi)`} testId="digest-missing">
        {d.missing.length === 0 ? <div className="text-sm opacity-60">Nessuna informazione mancante.</div> :
          d.missing.map(x => <Row key={x.id} x={x}><span className="text-xs opacity-80">{x.missing.join(", ")}</span></Row>)}
      </Card>
    </div>
  );
}
